import { render, staticRenderFns } from "./contentCourseExamMemoryGame.vue?vue&type=template&id=eff40b90&"
import script from "./contentCourseExamMemoryGame.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamMemoryGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports